import { z } from 'zod';

const environmentSchema = z.object({
  VITE_KEYCLOAK_URL: z.string().url(),
});

const potential = environmentSchema.safeParse(import.meta.env);

if (!potential.success) {
  throw Error(`Invalid environment variables: ${potential.error.message}`);
}

export const env = potential.data;
